import useScreen from '@/plugins/screen-plugin/screen';
import type { App } from 'vue';
import type { Config, Screen } from './type';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $screen: Screen;
    }
}

export default {
    install: (app: App, options: Config): void => {
        app.config.globalProperties.$screen = useScreen(options);
    }
};
